{
  "GENERAL": {
    "CLOSE": "Kapat",
    "SHOWING_RESULTS": "Showing {firstIndex}-{lastIndex} of {totalCount} items",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Ara",
      "EMPTY_STATE": "Kayıt bulunamadı"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "En az {count} gerekli"
  }
}
